module.exports = __webpack_public_path__ + "static/media/card-amex-logo.d6dd0d47.svg";